import { fbt } from 'fbtee'
import { Heart } from 'lucide-react'
import { CheckInIcon } from './CheckInIcon'
import { cn } from '../lib/utils'
import { GoingCheckIcon } from './GoingCheckIcon'

/** `checkedIn` swaps the going badge for "At the set" with the "I'm here" double check. */
export function InterestBadge({
  status,
  checkedIn = false,
  className,
}: {
  status: 'going' | 'interested'
  checkedIn?: boolean
  className?: string
}) {
  if (status === 'going') {
    return (
      <span className={cn('inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-going bg-going/10 px-1.5 py-0.5 rounded shrink-0', className)}>
        {checkedIn ? (
          <CheckInIcon className="size-3 shrink-0" />
        ) : (
          <GoingCheckIcon className="w-3 h-3 shrink-0" />
        )}
        {checkedIn
          ? fbt('At the set', 'Status badge shown next to a member who checked in at this set during the festival')
          : fbt('Going', 'Status badge shown next to a group member who marked Going on at least one set')}
      </span>
    )
  }
  return (
    <span className={cn('inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-interested bg-interested/10 px-1.5 py-0.5 rounded shrink-0', className)}>
      <Heart className="w-3 h-3 fill-interested text-interested shrink-0" />
      {fbt('Interested', 'Status badge shown next to a group member who marked Interested on a set or artist')}
    </span>
  )
}
